<template>
    <div>
        <div class="tsoft-notification" @click="isSidebarOpen = !isSidebarOpen">
            <i
                :class='`bx bxs-bell${calcAllUnreadNotifications.length > 0 ?
                    "-ring bx-tada text-orange" : ""}`'
            ></i>
            <div class="tsoft-notification_badge-order" v-if="calcAllUnreadNotifications.length > 0">
                <b-badge pill variant="light">{{ calcAllUnreadNotifications.length }}</b-badge>
            </div>
        </div>
        <b-sidebar
            v-model="isSidebarOpen"
            id="notification-sidebar"
            right
            backdrop
            width="30em"
        >
            <template #title>
                <div class="title-sidebar">
                    <strong class="ml-2">Уведомления</strong>
                </div>
            </template>
            <div>
                <div class="d-flex">
                    <b-form-checkbox
                        id="checkbox-notification-all"
                        v-model="changeAllChecked"
                        name="checkbox-send-notification"
                        :value="true"
                        :unchecked-value="false"
                        class="d-inline font-size-12 mr-2"
                        @change="checkAllNotification($event)"
                    >
                    </b-form-checkbox>
                    <b-form-radio-group
                        id="btn-radios-1"
                        v-model="selected"
                        :options="options"
                        name="radios-btn-default"
                        button-variant="outline-primary"
                        class="w-100 border-5 filter-value-notification mb-3"
                        buttons
                        @change="updateChecked"
                    >
                    </b-form-radio-group>
                </div>
                <div
                    class="notifications-scroll"
                    @scroll="onNotificationsScroll"
                    ref="notificationsScroll"
                >
                    <div v-if="selected === 'order'">
                        <div 
                            v-for="group in displayedGroupedOrderNotifications" :key="group.orderId || group.notifications[0].id" 
                            class="mb-1"
                        >
                            <!-- Группа из нескольких уведомлений -->
                            <div 
                                v-if="group.orderId && group.notifications.length > 1" 
                                class="notification-group"
                            >
                                <div class="mb-2 d-flex justify-content-between align-items-center">
                                    <span class="font-weight-bold">Поставка #{{ group.orderId }}</span>
                                    <div>
                                        <button class="btn btn-sm btn-outline-secondary" @click="markGroupRead(group.notifications)">
                                            Прочитать всё по поставке
                                        </button>
                                    </div>
                                </div>
                                <div v-for="(notify, idx) in group.notifications" :key="notify.id" class="d-flex">
                                    <b-form-checkbox
                                        :id="`checkbox-notification-${notify.id}`"
                                        v-model="notify.checked"
                                        name="checkbox-send-notification"
                                        :value="true"
                                        :unchecked-value="false"
                                        class="d-inline font-size-12 mr-2"
                                        style="margin-top: -4px;"
                                        @change="updateSelected"
                                    ></b-form-checkbox>
                                    <div :class="`notification_card mb-2`">
                                        <span v-html="notify.data.message" class="notify-message"></span>
                                        <div class="d-flex justify-content-between mt-2">
                                            <div class="mr-2 time-special">
                                                <small>Время: {{ formatDateTime(notify.created_at) }}</small>
                                            </div>
                                            <template v-if="notify.data.parameters.link">
                                                <span
                                                    v-if="notify.data.parameters.link.includes('order')"
                                                    class="sidebar-link sidebar-link-special"
                                                    @click="openOrderSidebar(getNumberFromString(notify.data.parameters.link), getParamFromString(notify.data.parameters.link, 'edit-order'), getParamFromString(notify.data.parameters.link), 'tab-order')"
                                                >{{ notify.data.parameters.linkText || 'Открыть' }}</span>
                                                <span
                                                    v-if="notify.data.parameters.link.includes('finance')"
                                                    class="sidebar-link sidebar-link-special"
                                                    @click="openFinanceSidebar(getNumberFromString(notify.data.parameters.link))"
                                                >{{ notify.data.parameters.linkText || 'Открыть' }}</span>
                                                <span
                                                    v-if="notify.data.parameters.link.includes('task')"
                                                    class="sidebar-link sidebar-link-special"
                                                    @click="openTaskSidebar({id: getNumberFromString(notify.data.message)})"
                                                >Открыть задачу</span>
                                                <span
                                                    v-if="notify.data.parameters.link.includes('email-tracking')"
                                                    class="sidebar-link sidebar-link-special"
                                                    @click="openEmailTrackingSidebar(getParamFromString(notify.data.parameters.link, 'email-tracking'))"
                                                >Открыть переписку</span>
                                            </template>
                                            <template v-else>
                                                <span
                                                    v-if="notify.data.parameters.type === 'task'"
                                                    class="sidebar-link sidebar-link-special"
                                                    @click="openTaskSidebar({id: getNumberFromString(notify.data.message)})"
                                                >Открыть задачу</span>
                                                <span
                                                    v-if="notify.data.parameters.type === 'finance'"
                                                    class="sidebar-link sidebar-link-special"
                                                    @click="openFinanceSidebar(getNumberFromString(notify.data.message))"
                                                >Открыть счет</span>
                                            </template>
                                        </div>
                                        <div class="close-notification">
                                            <b-icon
                                                icon="x"
                                                scale="1.7"
                                                variant="secondary"
                                                title="Закрыть"
                                                @click="actionCloseNotification(idx, notify.id)"
                                                style="cursor:pointer;"
                                                :animation="notify.read_at ? 'spin-reverse' : ''"
                                            ></b-icon>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Одиночное уведомление -->
                            <div v-else>
                                <div class="d-flex">
                                    <b-form-checkbox
                                        :id="`checkbox-notification-${group.notifications[0].id}`"
                                        v-model="group.notifications[0].checked"
                                        name="checkbox-send-notification"
                                        :value="true"
                                        :unchecked-value="false"
                                        class="d-inline font-size-12 mr-2"
                                        style="margin-top: -4px;"
                                        @change="updateSelected"
                                    ></b-form-checkbox>
                                    <div 
                                        :class="`notification_card mb-2`"
                                    >
                                        <span v-html="group.notifications[0].data.message" class="notify-message"></span>
                                        <div class="d-flex justify-content-between mt-2">
                                            <div class="mr-2 time-special">
                                                <small>Время: {{ formatDateTime(group.notifications[0].created_at) }}</small>
                                            </div>
                                            <template v-if="group.notifications[0].data.parameters.link">
                                                <span
                                                    v-if="group.notifications[0].data.parameters.link.includes('order')"
                                                    class="sidebar-link sidebar-link-special"
                                                    @click="openOrderSidebar(getNumberFromString(group.notifications[0].data.parameters.link), getParamFromString(group.notifications[0].data.parameters.link, 'edit-order'), getParamFromString(group.notifications[0].data.parameters.link), 'tab-order')"
                                                >{{ group.notifications[0].data.parameters.linkText || 'Открыть' }}</span>
                                                <span
                                                    v-if="group.notifications[0].data.parameters.link.includes('finance')"
                                                    class="sidebar-link sidebar-link-special"
                                                    @click="openFinanceSidebar(getNumberFromString(group.notifications[0].data.parameters.link))"
                                                >{{ group.notifications[0].data.parameters.linkText || 'Открыть' }}</span>
                                                <span
                                                    v-if="group.notifications[0].data.parameters.link.includes('task')"
                                                    class="sidebar-link sidebar-link-special"
                                                    @click="openTaskSidebar({id: getNumberFromString(group.notifications[0].data.message)})"
                                                >Открыть задачу</span>
                                                <span
                                                    v-if="group.notifications[0].data.parameters.link.includes('email-tracking')"
                                                    class="sidebar-link sidebar-link-special"
                                                    @click="openEmailTrackingSidebar(getParamFromString(group.notifications[0].data.parameters.link, 'email-tracking'))"
                                                >Открыть переписку</span>
                                            </template>
                                            <template v-else>
                                                <span
                                                    v-if="group.notifications[0].data.parameters.type === 'task'"
                                                    class="sidebar-link sidebar-link-special"
                                                    @click="openTaskSidebar({id: getNumberFromString(group.notifications[0].data.message)})"
                                                >Открыть задачу</span>
                                                <span
                                                    v-if="group.notifications[0].data.parameters.type === 'finance'"
                                                    class="sidebar-link sidebar-link-special"
                                                    @click="openFinanceSidebar(getNumberFromString(group.notifications[0].data.message))"
                                                >Открыть счет</span>
                                            </template>
                                        </div>
                                        <div class="close-notification">
                                            <b-icon
                                                icon="x"
                                                scale="1.7"
                                                variant="secondary"
                                                title="Закрыть"
                                                @click="actionCloseNotification(0, group.notifications[0].id)"
                                                style="cursor:pointer;"
                                                :animation="group.notifications[0].read_at ? 'spin-reverse' : ''"
                                            ></b-icon>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="displayedGroupedOrderNotifications.length === 0" class="text-center pb-3 pt-2">
                            <span class="text-secondary text-uppercase">Нет уведомлений</span>
                        </div>
                    </div>

                    <div v-else>
                        <div v-for="(notify, index) in displayedCalcNotifications" :key="notify.id" class="d-flex">
                            <b-form-checkbox
                                :id="`checkbox-notification-${notify.id}`"
                                v-model="notify.checked"
                                name="checkbox-send-notification"
                                :value="true"
                                :unchecked-value="false"
                                class="d-inline font-size-12 mr-2"
                                style="margin-top: -4px;"
                                @change="updateSelected"
                            ></b-form-checkbox>
                            <div 
                                :class="`notification_card mb-2`"
                            >
                                <span v-html="notify.data.message" class="notify-message"></span>
                                <div class="d-flex justify-content-between mt-2">
                                    <div class="mr-2 time-special">
                                        <small>Время: {{ formatDateTime(notify.created_at) }}</small>
                                    </div>
                                    <template v-if="notify.data.parameters.link">
                                        <span
                                            v-if="notify.data.parameters.link.includes('order')"
                                            class="sidebar-link sidebar-link-special"
                                            @click="openOrderSidebar(getNumberFromString(notify.data.parameters.link), getParamFromString(notify.data.parameters.link, 'edit-order'), getParamFromString(notify.data.parameters.link), 'tab-order')"
                                        >{{ notify.data.parameters.linkText || 'Открыть' }}</span>
                                        <span
                                            v-if="notify.data.parameters.link.includes('finance')"
                                            class="sidebar-link sidebar-link-special"
                                            @click="openFinanceSidebar(getNumberFromString(notify.data.parameters.link))"
                                        >{{ notify.data.parameters.linkText || 'Открыть' }}</span>
                                        <span
                                            v-if="notify.data.parameters.link.includes('task')"
                                            class="sidebar-link sidebar-link-special"
                                            @click="openTaskSidebar({id: getNumberFromString(notify.data.message)})"
                                        >Открыть задачу</span>
                                        <span
                                            v-if="notify.data.parameters.link.includes('email-tracking')"
                                            class="sidebar-link sidebar-link-special"
                                            @click="openEmailTrackingSidebar(getParamFromString(notify.data.parameters.link, 'email-tracking'))"
                                        >Открыть переписку</span>
                                    </template>
                                    <template v-else>
                                        <span
                                            v-if="notify.data.parameters.type === 'task'"
                                            class="sidebar-link sidebar-link-special"
                                            @click="openTaskSidebar({id: getNumberFromString(notify.data.message)})"
                                        >Открыть задачу</span>
                                        <span
                                            v-if="notify.data.parameters.type === 'finance'"
                                            class="sidebar-link sidebar-link-special"
                                            @click="openFinanceSidebar(getNumberFromString(notify.data.message))"
                                        >Открыть счет</span>
                                    </template>
                                </div>
                                <div class="close-notification">
                                    <b-icon
                                        icon="x"
                                        scale="1.7"
                                        variant="secondary"
                                        title="Закрыть"
                                        @click="actionCloseNotification(index, notify.id)"
                                        style="cursor:pointer;"
                                        :animation="notify.read_at ? 'spin-reverse' : ''"
                                    ></b-icon>
                                </div>
                            </div>
                        </div>
                        <div v-if="displayedCalcNotifications.length === 0" class="text-center pb-3 pt-2">
                            <span class="text-secondary text-uppercase">Нет уведомлений</span>
                        </div>
                    </div>
                </div>
            </div>
            <template
                v-if="calcAllUnreadNotifications.length > 0"
                #footer
            >
                <div class="footer-sidebar">
                    <button
                        v-if="isNotificationHasChecked"
                        class="btn btn-outline-secondary w-100"
                        @click="actionCloseAllNotificationChecked"
                    >Прочитать выделенные</button>
                    <button
                        v-if="!isNotificationHasChecked"
                        class="btn btn-outline-secondary w-100 mb-2"
                        @click="actionCloseAllNotification"
                    >Прочитать всё</button>
                </div>
            </template>
        </b-sidebar>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import {API_POST_NOTIFICATIONS_READ, API_POST_NOTIFICATIONS_READ_ALL} from '@/constants';
    import { openOrderSidebar } from '@/mixins/openOrderSidebar';
    import { openFinanceSidebar } from '@/mixins/openFinanceSidebar';
    import { openTaskSidebar } from '@/mixins/openTaskSidebar';
    import { openEmailTrackingSidebar } from '@/mixins/openEmailTrackingSidebar';

    export default {
        data() {
            return {
                selected: 'order',
                options: [
                    { text: 'Все', value: 'all' },
                    { text: 'Поставки', value: 'order' },
                    { text: 'Финансы', value: 'finance' },
                    // { text: 'Задачи', value: 'task' }
                ],
                isFirstLoad: true,
                changeAllChecked: false,
                isSidebarOpen: false,
                notificationsDisplayLimit: 30,
                notificationsDisplayStep: 30,
            }
        },
        mixins: [
            openOrderSidebar,
            openFinanceSidebar,
            openTaskSidebar,
            openEmailTrackingSidebar
        ],
        computed: {
            ...mapGetters("settings", ["app_focus"]),
            ...mapGetters("auth", ["currentUser", "isAuthenticated"]),
            notifications() {
                return this.$store.getters.NOTIFICATIONS
            },
            calcNotifications() {
                let filtered;
                if (this.selected !== 'all') {
                    filtered = this.notifications.filter(i => {
                        if (i.data && i.data.parameters && i.data.parameters.type && i.data.parameters.type === this.selected) {
                            return i
                        }
                    })
                } else {
                    filtered = this.notifications.filter(i => {
                        if (i.data && i.data.parameters && i.data.parameters.type) {
                            return i
                        }
                    })
                }
                
                // Сортируем по времени создания (самые свежие сначала)
                return filtered.sort((a, b) => {
                    return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
                });
            },
            calcNotificationsTask() {
                return this.notifications.filter(i => {
                    if (i.data && i.data.parameters && i.data.parameters.type && i.data.parameters.type === 'task') {
                        return i
                    }
                })
            },
            calcNotificationsOrder() {
                return this.notifications.filter(i => {
                    if (i.data && i.data.parameters && i.data.parameters.type && i.data.parameters.type === 'order') {
                        return i
                    }
                })
            },
            calcNotificationFinance() {
                return this.notifications.filter(i => {
                    if (i.data && i.data.parameters && i.data.parameters.type && i.data.parameters.type === 'finance') {
                        return i
                    }
                })
            },
            calcAllUnreadNotifications() {
                // Store уже содержит только непрочитанные уведомления
                // Поэтому возвращаем все уведомления из store
                return this.notifications;
            },
            isNotificationHasChecked() {
                return this.calcNotifications.some(i => i.checked)
            },
            groupedOrderNotifications() {
                if (this.selected !== 'order') return [];
                const groups = {};
                this.calcNotificationsOrder.forEach(notify => {
                    const orderId = notify.data?.parameters?.order_id;
                    if (orderId) {
                        if (!groups[orderId]) groups[orderId] = [];
                        groups[orderId].push(notify);
                    } else {
                        // Без order_id — отдельная группа с уникальным ключом
                        const key = 'no_order_' + notify.id;
                        groups[key] = [notify];
                    }
                });
                
                // Преобразуем в массив групп и сортируем по времени самого свежего уведомления
                return Object.entries(groups)
                    .map(([orderId, items]) => ({
                        orderId: orderId.startsWith('no_order_') ? null : orderId,
                        notifications: items.sort((a, b) => {
                            // Сортируем уведомления внутри группы по времени (самые свежие сначала)
                            return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
                        })
                    }))
                    .sort((a, b) => {
                        // Находим самое свежее уведомление в каждой группе
                        const aLatest = Math.max(...a.notifications.map(n => new Date(n.created_at).getTime()));
                        const bLatest = Math.max(...b.notifications.map(n => new Date(n.created_at).getTime()));
                        // Сортируем по убыванию (самые свежие сначала)
                        return bLatest - aLatest;
                    });
            },
            displayedGroupedOrderNotifications() {
                return this.groupedOrderNotifications.slice(0, this.notificationsDisplayLimit);
            },
            displayedCalcNotifications() {
                return this.calcNotifications.slice(0, this.notificationsDisplayLimit);
            },
        },
        watch: {
            notifications(newNotifications, oldNotifications) {
                if (newNotifications.length > 0) {
                    let isBellType = false;

                    if (newNotifications[newNotifications.length - 1].data.parameters && newNotifications[newNotifications.length - 1].data.parameters.place) {
                        try {
                            isBellType = newNotifications[newNotifications.length - 1].data.parameters.place.includes('bell');
                        } catch (error) {
                            console.error('Problems with finding .place', error);
                        }
                    }

                    if (newNotifications.length > oldNotifications.length && !this.isFirstLoad && isBellType) {
                        if (!this.app_focus) {
                            const favicon = document.getElementById("favicon");
                            favicon.href = "favicon-notification.svg";
                        }
                        this.playNotificationBell()
                    }

                    this.isFirstLoad = false
                }
            },
            selected() {
                this.notificationsDisplayLimit = this.notificationsDisplayStep;
            },

            isSidebarOpen() {
                if (!this.isSidebarOpen) {
                    this.updateChecked()
                }
            }
        },
        mounted() {
            this.$store.dispatch("GET_NOTIFICATIONS");
            this.setUnreadInterval();
        },
        methods: {
            async actionCloseNotification(index, id) {
                this.calcNotifications[index].read_at = 'reading';
                // уточнить для чего
                // const ind = this.calcNotifications.findIndex(i => i.id === id);

                await api.call('post', `${API_POST_NOTIFICATIONS_READ}/${id}`)
                    .then(() => this.$store.commit('READ_NOTIFICATIONS', id))
                    .catch(er => {
                        console.log(er);
                        // if (ind !== -1 && !this.notificationsLocal[type][ind]._retry) {
                        //     this.notificationsLocal[type][ind]._retry = true;
                        //     this.actionCloseNotification(index, id, type);
                        // }
                    })
            },
            actionCloseAllNotification() {
                this.calcNotifications.forEach(async (notify, index) => {
                    await this.actionCloseNotification(index, notify.id);
                })
                // api.call("post", API_POST_NOTIFICATIONS_READ_ALL).then(({data}) => {
                //     this.notificationsLocal = initialNotifications()
                // })
            },
            actionCloseAllNotificationChecked() {
                this.calcNotifications.forEach(async (notify, index) => {
                    if (notify.checked) {
                        await this.actionCloseNotification(index, notify.id);
                    }
                })
            },
            formatDateTime(dateString) {
                if (!dateString) {
                    return dateString
                }
                let formattedDate = (new Date(dateString)).toLocaleDateString()
                let formattedTime = (new Date(dateString)).toLocaleTimeString()
                let formattedTimeArray = formattedTime.split(":");

                return formattedDate + " " + formattedTimeArray[0] + ":" + formattedTimeArray[1]
            },

            playNotificationBell() {
                const audio = new Audio('sounds/notificationBell.mp3');
                audio.volume = .4;
                audio.play()
            },

            getNumberFromString(str) {
                return str = str.replace(/\D/g, ' ').trim().split(' ')[0];
            },

            getParamFromString(str, param = 'tab-order') {
                const params = new URLSearchParams(str);
                return params.get(param);
            },

            updateSelected() {
                const temp = this.selected;
                this.selected = null;
                this.selected = temp;
            },

            updateChecked() {
                this.changeAllChecked = false;
                this.updateSelected();
                this.calcNotifications.forEach(i => i.checked = false)
            },

            checkAllNotification(e) {
                this.updateSelected();
                this.calcNotifications.forEach(i => i.checked = e)
            },

            setUnreadInterval() {
                setInterval(() => {
                    if (this.isAuthenticated && !this.isNotificationHasChecked) {
                        this.$store.dispatch('GET_NOTIFICATIONS');
                    }
                }, 30000);
            },
            async markGroupRead(notifications) {
                for (let i = 0; i < notifications.length; i++) {
                    await this.actionCloseNotification(i, notifications[i].id);
                }
            },
            onNotificationsScroll(e) {
                const el = e.target;
                if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10) {
                    // Почти дошли до низа — подгружаем еще
                    this.notificationsDisplayLimit += this.notificationsDisplayStep;
                }
            },
        }
    }
</script>
